export default __webpack_public_path__ + "static/media/Armguards of the Howling Giant.6683d707.jpg";